// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Bmgd","content":"styles_content__3wAe4"};